export default {
    // props: {
    //     Id: String,
    //     default: ''
    // },
    data() {
        return {
            fullscreenLoading: false,
            Id: '',
            url: {
                GetNews: SZH.assets.api + '/Market/GetNews'
            },
            details: {
                F_Title: '',
                F_UpdateTime: '',
                F_AttachName: '',
                F_AttachUrl: '',
                F_Content: ''
            }
        }
    },
    methods: {
        loadData() {
            let self = this
            self.fullscreenLoading = true
            self.$http.post(self.url.GetNews, {
                keyValue: self.Id
            }).then(result => {
                if (result.state == 1 && result.data) {
                    self.fullscreenLoading = false
                    // self.$message.success('获取成功')
                    self.details = result.data
                } else {
                    self.fullscreenLoading = false
                    self.$message.error(result.message)
                    self.details = []
                }
            })
        },
        Download(url) {
            window.open(SZH.assets.image + '/' + url)
        },
        goBack() {
            let self = this
            self.$router.go(-1)
            // history.go(-1)//返回浏览器历史的上一页
        }
    },
    computed: {},
    components: {},
    mounted() {
        this.Id = this.$route.query.Id
        this.loadData()
    }
}



// WEBPACK FOOTER //
// ./src/views/AuctionHall/AuctionDownload/AuctionDownload.js